import { authenticatedAxiosInstance } from "@/lib/data/http";
import { baseReportsRoutes } from "@/lib/data/requests/matters/matter";
import { type APIResponse, type ReportFilterPreset } from "@/lib/types";

export type CreateReportFilterPresetInput = {
  reportFilterPresetColumns: string[];
  reportFilterPresetDescription?: string;
  reportFilterPresetFilterOptions: Record<string, unknown>;
  reportFilterPresetName: string;
  reportFilterPresetReportType: string;
};

export type RetrieveReportFilterPresetsInput =
  | {
      reportFilterPresetReportType?: string;
    }
  | undefined;

export type DeleteReportFilterPresetInput = {
  reportFilterPresetId: string;
};

export const createReportFilterPresetV1 = (
  data: CreateReportFilterPresetInput,
) => {
  return authenticatedAxiosInstance
    .post<
      APIResponse<ReportFilterPreset>
    >(`${baseReportsRoutes}/report-filter-preset`, data)
    .then((res) => res.data);
};

export const retrieveReportFilterPresetsV1 = (
  data: RetrieveReportFilterPresetsInput = {},
) => {
  return authenticatedAxiosInstance
    .post<
      APIResponse<ReportFilterPreset[]>
    >(`${baseReportsRoutes}/report-filter-presets`, data)
    .then((res) => res.data);
};

export const deleteReportFilterPresetV1 = ({
  reportFilterPresetId,
}: DeleteReportFilterPresetInput) => {
  return authenticatedAxiosInstance
    .delete<
      APIResponse<ReportFilterPreset>
    >(`${baseReportsRoutes}/report-filter-preset/${reportFilterPresetId}`)
    .then((res) => res.data);
};
